import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import { PATH } from '../../../const'

export const useOnSuccess = () => {
  const navigate = useNavigate()
  return () => {
    navigate(PATH.noteApprovals)
    toast.success(`Submission successful`)
  }
}
